const angular = require('angular')
const composeService = require('./composeService')
const composeCtrl = require('./composeCtrl')
const attachmentInfo = require('./attachmentInfo')
require('./composeDirectives')

module.exports = angular.module('hxphone.compose', ['hxphone.services', 'hxphone.compose.composeDirectives'])
  .factory('composeService', composeService)
  .controller('composeCtrl', composeCtrl)
  .directive('attachmentInfo', attachmentInfo)



// WEBPACK FOOTER //
// ./src/js/mail/compose/module.js